/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react'
import BraftEditor, { EditorState } from 'braft-editor'
//@ts-ignore
import MaxLength from 'braft-extensions/dist/max-length'
import 'braft-editor/dist/index.css'
import OSS from 'ali-oss'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { useOssStore } from '@/stores/ossSelect'
interface Props {
  saveEditorContent: (s: string) => void // 文本数据改变
  dataSource?: string
}

export type ResultType = '上传中' | '成功' | '失败'

export interface UploadFileItem
  extends Partial<Pick<RcFile, 'size' | 'name' | 'uid' | 'type'>> {
  uid: string
  name: string
  resultType: ResultType
  errorMessage?: string
  originFile: File
  osspath?: string
  url: string
}

const Customeditor = forwardRef((props: Props, ref: any) => {
  const { dataSource, saveEditorContent } = props
  const [editorState, seteditorState] = useState<EditorState>(
    BraftEditor.createEditorState(dataSource),
  )
  const { accessKeyId, accessKeySecret } = useOssStore((state) => state)
  const uploadQueueRef = useRef<UploadFileItem[]>([])
  const ossClientRef = useRef<{
    ossClient: OSS
    timestamp: number
  }>()

  const LIMIT = 500
  const options = {
    defaultValue: LIMIT, // 指定默认限制数，如不指定则为Infinity(无限)
  }

  BraftEditor.use(MaxLength(options))

  useImperativeHandle(
    ref,
    () => ({
      restate,
    }),
    [],
  )

  const getValidatedFileItem = (item: RcFile): UploadFileItem => {
    const baseItem: UploadFileItem = {
      uid: new Date().getTime().toString(),
      name: item.name,
      size: item.size,
      type: item.type,
      resultType: '上传中',
      originFile: item,
      url: '',
    }
    return baseItem
  }

  // 传入uid开始下载，避免重复执行
  const startUpload = async (uidList: string[]) => {
    if (uidList.length < 1) {
      return
    }
    for (let i = 0; i < uploadQueueRef.current.length; i++) {
      if (!uidList.includes(uploadQueueRef.current[i].uid)) {
        // 跳过不需要下载的uid
        continue
      }
      if (uploadQueueRef.current[i].resultType !== '上传中') {
        // 不是上传中的文件跳过
        continue
      }
      const newpath =
        `srm/upload/noticeFile/${ossClientRef.current?.timestamp}/` +
        uploadQueueRef.current[i].name
      let res: any = {
        name: newpath,
      }
      try {
        res = await ossClientRef.current?.ossClient.put(
          newpath,
          uploadQueueRef.current[i].originFile,
        )
      } catch (e) {
        uploadQueueRef.current[i].resultType = '失败'
        uploadQueueRef.current[i].errorMessage = '连接超时，请重试'
        continue
      }
      if (res?.res?.status !== 200) {
        uploadQueueRef.current[i].resultType = '失败'
        uploadQueueRef.current[i].errorMessage = '连接超时，请重试'
      } else {
        uploadQueueRef.current[i].resultType = '成功'
        uploadQueueRef.current[i].osspath = newpath
        uploadQueueRef.current[i].url = res.url
        return res
      }
    }
  }

  // 上传前验证文件是否符合要求
  const validateFile = (file: any) => {
    const isImage = file.type.startsWith('image/') // 验证文件类型为图片
    if (!isImage) {
      message.error('只能上传图片！')
      return false
    }

    if (file.size > 1024 * 1024 * 512) {
      // 限制最大文件大小为512MB
      message.error('上传失败：请勿上传超过512M的文件！')
      return false
    }

    return true
  }

  // 上传文件
  const uploadfile = async (params: any) => {
    if (params.file) {
      const nodupFileList: any[] = []
      const uploadUidList: string[] = []
      nodupFileList.push(params.file)
      // 添加新文件到下载队列
      const newFileList: UploadFileItem[] = nodupFileList.map((item) => {
        const baseItem = getValidatedFileItem(item)
        if (baseItem.resultType === '上传中') {
          uploadUidList.push(baseItem.uid)
        }
        return baseItem
      })
      uploadQueueRef.current.push(...newFileList)
      const res = await startUpload(uploadUidList)
      params.success({
        url: res.url,
        meta: {
          title: res.name,
          alt: res.name,
        },
      })
    }
  }

  // 富文本内容修改
  const handleChange = (editor: EditorState) => {
    const htmlContent = editor.toHTML()
    saveEditorContent(htmlContent)
    seteditorState(editor)
  }

  // 自定义hook
  const hooks = {
    'toggle-link': ({ href, target }: any) => {
      href = href.indexOf('http') === 0 ? href : `http://${href}`
      return { href, target }
    },
  }

  useEffect(() => {
    if (accessKeyId && accessKeySecret) {
      ossClientRef.current = {
        ossClient: new OSS({
          accessKeyId: accessKeyId,
          accessKeySecret: accessKeySecret,
          bucket: process.env.REACT_APP_OSS_BUCKET,
          region: 'oss-cn-shanghai',
        }),
        timestamp: new Date().getTime(),
      }
    }
  }, [accessKeyId, accessKeySecret])

  const restate = () => {
    dataSource !== '<p></p>' &&
      seteditorState(BraftEditor.createEditorState(dataSource))
    // eslint-disable-next-line
  }

  return (
    <BraftEditor
      language="zh"
      //@ts-ignore
      maxLength={LIMIT}
      value={editorState}
      onChange={handleChange}
      hooks={hooks}
      controls={[
        'bold',
        'italic',
        'underline',
        'strike-through',
        'list-ul',
        'list-ol',
        'blockquote',
        'code',
        'font-size',
        'text-align',
        'line-height',
        'letter-spacing',
      ]}
      excludeControls={['list-ul', 'list-ol', 'blockquote', 'code']}
      placeholder="请输入正文"
    />
  )
})

Customeditor.displayName = 'Customeditor'

export default Customeditor
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react'
import BraftEditor, { EditorState } from 'braft-editor'
//@ts-ignore
import MaxLength from 'braft-extensions/dist/max-length'
import 'braft-editor/dist/index.css'
import OSS from 'ali-oss'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { useOssStore } from '@/stores/ossSelect'
interface Props {
  saveEditorContent: (s: string) => void // 文本数据改变
  dataSource?: string
}

export type ResultType = '上传中' | '成功' | '失败'

export interface UploadFileItem
  extends Partial<Pick<RcFile, 'size' | 'name' | 'uid' | 'type'>> {
  uid: string
  name: string
  resultType: ResultType
  errorMessage?: string
  originFile: File
  osspath?: string
  url: string
}

const Customeditor = forwardRef((props: Props, ref: any) => {
  const { dataSource, saveEditorContent } = props
  const [editorState, seteditorState] = useState<EditorState>(
    BraftEditor.createEditorState(dataSource),
  )
  const { accessKeyId, accessKeySecret } = useOssStore((state) => state)
  const uploadQueueRef = useRef<UploadFileItem[]>([])
  const ossClientRef = useRef<{
    ossClient: OSS
    timestamp: number
  }>()

  const LIMIT = 500
  const options = {
    defaultValue: LIMIT, // 指定默认限制数，如不指定则为Infinity(无限)
  }

  BraftEditor.use(MaxLength(options))

  useImperativeHandle(
    ref,
    () => ({
      restate,
    }),
    [],
  )

  const getValidatedFileItem = (item: RcFile): UploadFileItem => {
    const baseItem: UploadFileItem = {
      uid: new Date().getTime().toString(),
      name: item.name,
      size: item.size,
      type: item.type,
      resultType: '上传中',
      originFile: item,
      url: '',
    }
    return baseItem
  }

  // 传入uid开始下载，避免重复执行
  const startUpload = async (uidList: string[]) => {
    if (uidList.length < 1) {
      return
    }
    for (let i = 0; i < uploadQueueRef.current.length; i++) {
      if (!uidList.includes(uploadQueueRef.current[i].uid)) {
        // 跳过不需要下载的uid
        continue
      }
      if (uploadQueueRef.current[i].resultType !== '上传中') {
        // 不是上传中的文件跳过
        continue
      }
      const newpath =
        `srm/upload/noticeFile/${ossClientRef.current?.timestamp}/` +
        uploadQueueRef.current[i].name
      let res: any = {
        name: newpath,
      }
      try {
        res = await ossClientRef.current?.ossClient.put(
          newpath,
          uploadQueueRef.current[i].originFile,
        )
      } catch (e) {
        uploadQueueRef.current[i].resultType = '失败'
        uploadQueueRef.current[i].errorMessage = '连接超时，请重试'
        continue
      }
      if (res?.res?.status !== 200) {
        uploadQueueRef.current[i].resultType = '失败'
        uploadQueueRef.current[i].errorMessage = '连接超时，请重试'
      } else {
        uploadQueueRef.current[i].resultType = '成功'
        uploadQueueRef.current[i].osspath = newpath
        uploadQueueRef.current[i].url = res.url
        return res
      }
    }
  }

  // 上传前验证文件是否符合要求
  const validateFile = (file: any) => {
    const isImage = file.type.startsWith('image/') // 验证文件类型为图片
    if (!isImage) {
      message.error('只能上传图片！')
      return false
    }

    if (file.size > 1024 * 1024 * 512) {
      // 限制最大文件大小为512MB
      message.error('上传失败：请勿上传超过512M的文件！')
      return false
    }

    return true
  }

  // 上传文件
  const uploadfile = async (params: any) => {
    if (params.file) {
      const nodupFileList: any[] = []
      const uploadUidList: string[] = []
      nodupFileList.push(params.file)
      // 添加新文件到下载队列
      const newFileList: UploadFileItem[] = nodupFileList.map((item) => {
        const baseItem = getValidatedFileItem(item)
        if (baseItem.resultType === '上传中') {
          uploadUidList.push(baseItem.uid)
        }
        return baseItem
      })
      uploadQueueRef.current.push(...newFileList)
      const res = await startUpload(uploadUidList)
      params.success({
        url: res.url,
        meta: {
          title: res.name,
          alt: res.name,
        },
      })
    }
  }

  // 富文本内容修改
  const handleChange = (editor: EditorState) => {
    const htmlContent = editor.toHTML()
    saveEditorContent(htmlContent)
    seteditorState(editor)
  }

  // 自定义hook
  const hooks = {
    'toggle-link': ({ href, target }: any) => {
      href = href.indexOf('http') === 0 ? href : `http://${href}`
      return { href, target }
    },
  }

  useEffect(() => {
    if (accessKeyId && accessKeySecret) {
      ossClientRef.current = {
        ossClient: new OSS({
          accessKeyId: accessKeyId,
          accessKeySecret: accessKeySecret,
          bucket: process.env.REACT_APP_OSS_BUCKET,
          region: 'oss-cn-shanghai',
        }),
        timestamp: new Date().getTime(),
      }
    }
  }, [accessKeyId, accessKeySecret])

  const restate = () => {
    dataSource !== '<p></p>' &&
      seteditorState(BraftEditor.createEditorState(dataSource))
    // eslint-disable-next-line
  }

  return (
    <BraftEditor
      language="zh"
      //@ts-ignore
      maxLength={LIMIT}
      value={editorState}
      onChange={handleChange}
      hooks={hooks}
      controls={[
        'bold',
        'italic',
        'underline',
        'strike-through',
        'list-ul',
        'list-ol',
        'blockquote',
        'code',
        'font-size',
        'text-align',
        'line-height',
        'letter-spacing',
      ]}
      excludeControls={['list-ul', 'list-ol', 'blockquote', 'code']}
      placeholder="请输入正文"
    />
  )
})

Customeditor.displayName = 'Customeditor'

export default Customeditor
